export const AIConsultantsData = [
  { 
    id: 'ai-dietitian', 
    name: "Ananya (AI Dietitian)", 
    service: "Dietitian", 
    type: "dietitian", 
    isAi: true, 
    profileImage: "/assets/ai-agents/ananya_dietitian.png", 
    rating: 4, 
    yearsOfExperience: 5, 
    bio: "I am Ananya, an expert AI Dietitian available 24/7. I offer AI-generated advice. Consult a human doctor for medical emergencies.", 
    hasReferralSystem: false 
  },
  { 
    id: 'ai-astrologer', 
    name: "Prakash (AI Astrologer)", 
    service: "Astrologer", 
    type: "astrologer", 
    isAi: true, 
    profileImage: "/assets/ai-agents/prakash_astrologer.png", 
    rating: 4, 
    yearsOfExperience: 10, 
    bio: "I am Prakash, your AI Astrologer. I have analyzed thousands of charts.", 
    hasReferralSystem: false 
  },
  { 
    id: 'ai-ayurvedacharya', 
    name: "Narayan (AI Ayurvedacharya)", 
    service: "Ayurvedacharya", 
    type: "ayurvedacharya", 
    isAi: true, 
    profileImage: "/assets/ai-agents/narayan_ayurveda.png", 
    rating: 4, 
    yearsOfExperience: 8, 
    bio: "I am Narayan, an AI expert in Ayurveda.", 
    hasReferralSystem: false 
  },
  { 
    id: 'ai-reiki', 
    name: "Kavya (AI Reiki Healer)", 
    service: "Reiki Healer", 
    type: "reiki-healer", 
    isAi: true, 
    profileImage: "/assets/ai-agents/kavya_reiki.png", 
    rating: 4, 
    yearsOfExperience: 6, 
    bio: "I am Kavya, an AI Reiki Healer guiding your energy.", 
    hasReferralSystem: false 
  },
  { 
    id: 'ai-numerologer', 
    name: "Vedika (AI Numerologer)", 
    service: "Numerologer", 
    type: "numerologer", 
    isAi: true, 
    profileImage: "/assets/ai-agents/vedika_numerology.png", 
    rating: 4, 
    yearsOfExperience: 7, 
    bio: "I am Vedika, your AI guide to the numbers.", 
    hasReferralSystem: false 
  },
  { 
    id: 'ai-tarot', 
    name: "Roshni (AI Tarot Card Reader)", 
    service: "Tarot Card Reader", 
    type: "tarot-card-reader", 
    isAi: true, 
    profileImage: "/assets/ai-agents/roshni_tarot.png", 
    rating: 4, 
    yearsOfExperience: 4, 
    bio: "I am Roshni, an AI Tarot Card Reader.", 
    hasReferralSystem: false 
  },
  { 
    id: 'ai-home-tutor', 
    name: "Vidyasagar (AI Home Tutor)", 
    service: "Home Tutor", 
    type: "home-tutor", 
    isAi: true, 
    profileImage: "/assets/ai-agents/vidyasagar_tutor.png", 
    rating: 4, 
    yearsOfExperience: 15, 
    bio: "I am Vidyasagar, a knowledgeable AI Home Tutor. I can help with your studies.", 
    hasReferralSystem: false 
  }
];
